import { defineComponent as _defineComponent } from 'vue'
import VignetteLogo from "@/components/AlmanacPlusLogo.vue";
import { ApiService, LogService, RouterService } from "@/services";
import { useBriefcaseStore } from "@/pinia/briefcase";
import { LogLevel, LogLevels } from "@/types";
import { useSessionStore } from "@/pinia/session";
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router/composables";
import { useViewAnalytics } from "@/composition/useViewAnalytics";


export default /*#__PURE__*/_defineComponent({
  __name: 'DebugView',
  setup(__props) {

const router = useRouter();

const sessionStore = useSessionStore();
const briefcaseStore = useBriefcaseStore();

const briefcaseProfileId = ref(30);
const pageName = ref("Debug");
const { pageTitle } = useViewAnalytics(pageName);

const items = ref<LogLevel[]>(Object.values(LogLevels.getAll()));

const sentryLogLevel = computed({
  get: () => LogService.sentryLogLevel.label,
  set: (value: string) => {
    LogService.sentryLogLevel = LogLevels.fromString(value);
  },
});
const consoleLogLevel = computed({
  get: () => LogService.consoleLogLevel.label,
  set: (value: string) => {
    LogService.consoleLogLevel = LogLevels.fromString(value);
  },
});
const getBriefcase = () => {
  ApiService.refreshBriefcase();
};
const toggleBriefcase = () => {
  return;
};
const addToBriefcase = () => {
  return;
};
const removeFromBriefcase = () => {
  return;
};
const logDebug = () => {
  LogService.debug("Debug message.");
};
const logInfo = () => {
  LogService.info("Info message.");
};
const logWarn = () => {
  LogService.warn("Warning message.");
};
const logError = () => {
  LogService.error("Error message.");
};
const logFatal = () => {
  LogService.fatal("Fatal error message.");
};
const callAppConfigEndpoint = () => {
  ApiService.getAppConfig();
};
const callSessionEndpoint = () => {
  ApiService.getSession();
};

onMounted(() => {
  if (!sessionStore.isStaffOrSuperUser) {
    RouterService.navigateToHome(router);
  }
});

return { __sfc: true,router, sessionStore, briefcaseStore, briefcaseProfileId, pageName, pageTitle, items, sentryLogLevel, consoleLogLevel, getBriefcase, toggleBriefcase, addToBriefcase, removeFromBriefcase, logDebug, logInfo, logWarn, logError, logFatal, callAppConfigEndpoint, callSessionEndpoint, VignetteLogo }
}

})